export default {
    // AUTH
    USER_LOGIN: 'USER_LOGIN',
    CHECK_LOGIN: 'CHECK_LOGIN',
    LOGOUT: 'LOGOUT',
    GET_AVL_LANGUAGES: 'GET_AVL_LANGUAGES',


    // USERS
    GET_USER_LIST: 'GET_USER_LIST',
    GET_USER_DETAILS: 'GET_USER_DETAILS',
    ADD_NEW_USER: 'ADD_NEW_USER',
    USER_REGISTRATION: 'USER_REGISTRATION',
    CLEAR_USER_REGISTRATION: 'CLEAR_USER_REGISTRATION',
    SUBMIT_USER_REG_OTP: 'SUBMIT_USER_REG_OTP',
    CLEAR_USER_LOGIN: 'CLEAR_USER_LOGIN',
    RESEND_USER_REG_OTP: 'RESEND_USER_REG_OTP',
    RESET_PASSWORD: 'RESET_PASSWORD',


    //QUESTIONNAIRES
    GET_QUESTIONNAIRE_LIST: 'GET_QUESTIONNAIRE_LIST',
    GET_QUESTIONNAIRE_DETAILS: 'GET_QUESTIONNAIRE_DETAILS',
    GET_QUESTIONNAIRE_DETAILS_BG: 'GET_QUESTIONNAIRE_DETAILS_BG',
    SAVE_QUESTIONNAIRE_DETAILS: 'SAVE_QUESTIONNAIRE_DETAILS',
    SAVE_QUESTIONNAIRE_TRANSLATIONS: 'SAVE_QUESTIONNAIRE_TRANSLATIONS',
    ADD_NEW_QUESTIONNAIRE: 'ADD_NEW_QUESTIONNAIRE',
    CREATE_SECTION: 'CREATE_SECTION',
    DELETE_SECTION: 'DELETE_SECTION',
    UPDATE_SECTION: 'UPDATE_SECTION',
    UPDATE_SECTION_QUESTION: 'UPDATE_SECTION_QUESTION',
    ADD_NEW_SEC_QUESTION: 'ADD_NEW_SEC_QUESTION',
    DELETE_QUESTION: 'DELETE_QUESTION',
    ADD_NEW_OPTION: 'ADD_NEW_OPTION',
    DELETE_OPTION: 'DELETE_OPTION',
    UPDATE_OPTION: 'UPDATE_OPTION',
    ACTIVATE_QUESTIONNAIRE: 'ACTIVATE_QUESTIONNAIRE',
    DELETE_QUESTIONNAIRE: 'DELETE_QUESTIONNAIRE',


    //TRAINING MODULES
    GET_TRAINING_MODULE_LIST: 'GET_TRAINING_MODULE_LIST',
    GET_TRAINING_MODULE_DETAILS: 'GET_TRAINING_MODULE_DETAILS',
    GET_TRAINING_MODULE_DETAILS_BG: 'GET_TRAINING_MODULE_DETAILS_BG',
    ADD_NEW_TRAINING_MODULE: 'ADD_NEW_TRAINING_MODULE',
    SAVE_TRAINING_MODULE_DETAILS: 'SAVE_TRAINING_MODULE_DETAILS',
    CREATE_TASK: 'CREATE_TASK',
    UPDATE_TASK: 'UPDATE_TASK',
    UPDATE_TM_QUESTIONNAIRE: 'UPDATE_TM_QUESTIONNAIRE',
    CREATE_TM_QUESTIONNAIRE: 'CREATE_TM_QUESTIONNAIRE',
    DELETE_TM_QUESTIONNAIRE: 'DELETE_TM_QUESTIONNAIRE',
    DELETE_TM_TASK: 'DELETE_TM_TASK',
    DELETE_TRAINING_MODULE: 'DELETE_TRAINING_MODULE',
    ACTIVATE_TRAINING_MODULE: 'ACTIVATE_TRAINING_MODULE',
    TASK_IMAGE_UPLOAD: 'TASK_IMAGE_UPLOAD',
    GET_TRAINING_MODULE_TASKS: 'GET_TRAINING_MODULE_TASKS',
    CREATE_ARTICLE: 'CREATE_ARTICLE',
    UPDATE_ARTICLE: 'UPDATE_ARTICLE',
    DELETE_ARTICLE: 'DELETE_ARTICLE',

    //TROPHY SETTINGS
    GET_TROPHY_SETTINGS_LIST: 'GET_TROPHY_SETTINGS_LIST',
    GET_TROPHY_SETTINGS_DETAILS: 'GET_TROPHY_SETTINGS_DETAILS',
    SAVE_TROPHY_SETTINGS_DETAILS: 'SAVE_TROPHY_SETTINGS_DETAILS',

    //BREATHING RHYTHM
    GET_BREATHING_RHYTHM_LIST: 'GET_BREATHING_RHYTHM_LIST',
    ADD_NEW_BREATHING_RHYTHM: 'ADD_NEW_BREATHING_RHYTHM',
    GET_BREATHING_DETAILS: 'GET_BREATHING_DETAILS',
    SAVE_BR_DETAILS: 'SAVE_BR_DETAILS',
    DELETE_BREATHING_RHYTHM: 'DELETE_BREATHING_RHYTHM',

    //ASSESSMENT TEST
    GET_ENDURANCE_ACTIVITY_LIST: 'GET_ASSESSMENT_TEST_LIST',
    ADD_NEW_ASSESSMENT_TEST: 'ADD_NEW_ASSESSMENT_TEST',
    GET_ENDURANCE_ACTIVITY_DETAILS: 'GET_ASSESSMENT_TEST_DETAILS',
    SAVE_ASSESSMENT_TEST_DETAILS: 'SAVE_ASSESSMENT_TEST_DETAILS',
    SAVE_ASSESSMENT_TEST_TRANSLATIONS: 'SAVE_ASSESSMENT_TEST_TRANSLATIONS',
    GET_ASSESSMENT_TEST_DETAILS_BG: 'GET_ASSESSMENT_TEST_DETAILS_BG',
    ADD_NEW_ENDURANCE_CATEGORY: 'ADD_NEW_ENDURANCE_CATEGORY',
    UPDATE_ENDURANCE_CATEGORY: 'UPDATE_ENDURANCE_CATEGORY',
    DELETE_ASSESSMENT_TEST: 'DELETE_ASSESSMENT_TEST',
    DELETE_ENDURANCE_CATEGORY: 'DELETE_ENDURANCE_CATEGORY',

    //RPE SALE
    GET_RPE_SCALE_LIST: 'GET_RPE_SCALE_LIST',
    ADD_NEW_RPE_SCALE: 'ADD_NEW_RPE_SCALE',
    GET_RPE_SCALE_DETAILS: 'GET_RPE_SCALE_DETAILS',
    GET_RPE_SCALE_DETAILS_BG: 'GET_RPE_SCALE_DETAILS_BG',
    SAVE_RPE_SCALE_DETAILS: 'SAVE_RPE_SCALE_DETAILS',
    SAVE_RPE_SCALE_TRANSLATIONS: 'SAVE_RPE_SCALE_TRANSLATIONS',
    DELETE_RPE_SCALE: 'DELETE_RPE_SCALE',

    //ENDURANCE CATEGORY
    GET_ENDURANCE_ACTIVITY_LIST: 'GET_ENDURANCE_ACTIVITY_LIST',
    ADD_NEW_ENDURANCE_ACTIVITY: 'ADD_NEW_ENDURANCE_ACTIVITY',
    GET_ENDURANCE_ACTIVITY_DETAILS: 'GET_ENDURANCE_ACTIVITY_DETAILS',
    SAVE_ENDURANCE_ACTIVITY_DETAILS: 'SAVE_ENDURANCE_ACTIVITY_DETAILS',
    GET_ENDURANCE_ACTIVITY_DETAILS_BG: 'GET_ENDURANCE_ACTIVITY_DETAILS_BG',
    SAVE_ENDURANCE_ACTIVITY_TRANSLATIONS: 'SAVE_ENDURANCE_ACTIVITY_TRANSLATIONS',
    DELETE_ENDURANCE_ACTIVITY: 'DELETE_ENDURANCE_ACTIVITY',

    //SIDE EFFECT
    GET_SIDE_EFFECT_LIST: 'GET_SIDE_EFFECT_LIST',
    ADD_NEW_SIDE_EFFECT: 'ADD_NEW_SIDE_EFFECT',
    GET_SIDE_EFFECT_DETAILS: 'GET_SIDE_EFFECT_DETAILS',
    SAVE_SIDE_EFFECT_DETAILS: 'SAVE_SIDE_EFFECT_DETAILS',
    GET_SIDE_EFFECT_DETAILS_BG: 'GET_SIDE_EFFECT_DETAILS_BG',
    SAVE_SIDE_EFFECT_TRANSLATIONS: 'SAVE_SIDE_EFFECT_TRANSLATIONS',
    DELETE_SIDE_EFFECT: 'DELETE_SIDE_EFFECT',

    //RECIPE
    GET_RECIPE_LIST: 'GET_RECIPE_LIST',
    ADD_NEW_RECIPE: 'ADD_NEW_RECIPE',
    GET_RECIPE_DETAILS: 'GET_RECIPE_DETAILS',
    SAVE_RECIPE_DETAILS: 'SAVE_RECIPE_DETAILS',
    GET_RECIPE_DETAILS_BG: 'GET_RECIPE_DETAILS_BG',
    SAVE_RECIPE_TRANSLATIONS: 'SAVE_RECIPE_TRANSLATIONS',
    DELETE_RECIPE: 'DELETE_RECIPE',
    GET_RECIPE_CATEGORIES: 'GET_RECIPE_CATEGORIES',

    //EXERCISE
    GET_EXERCISE_LIST: 'GET_EXERCISE_LIST',
    ADD_NEW_EXERCISE: 'ADD_NEW_EXERCISE',
    GET_EXERCISE_DETAILS: 'GET_EXERCISE_DETAILS',
    SAVE_EXERCISE_DETAILS: 'SAVE_EXERCISE_DETAILS',
    GET_EXERCISE_DETAILS_BG: 'GET_EXERCISE_DETAILS_BG',
    SAVE_EXERCISE_TRANSLATIONS: 'SAVE_EXERCISE_TRANSLATIONS',
    DELETE_EXERCISE: 'DELETE_EXERCISE',

    //PROGRESSION TABLE
    GET_PT_LIST: 'GET_PT_LIST',
    ADD_NEW_PT: 'ADD_NEW_PT',
    GET_PT_DETAILS: 'GET_PT_DETAILS',
    SAVE_PT_DETAILS: 'SAVE_PT_DETAILS',
    GET_PT_DETAILS_BG: 'GET_PT_DETAILS_BG',
    SAVE_PT_TRANSLATIONS: 'SAVE_PT_TRANSLATIONS',
    DELETE_PT: 'DELETE_PT',
    GET_TRAINING_MODULES: 'GET_TRAINING_MODULES',
    GET_EXERCISES: 'GET_EXERCISES',
    ADD_NEW_PT_COACHING: 'ADD_NEW_PT_COACHING',
    GET_PT_COACHING_LIST: 'GET_PT_COACHING_LIST',
    EDIT_PT_COACHING: 'EDIT_PT_COACHING',
    DELETE_PT_COACHING: 'DELETE_PT_COACHING',


    // GET_PATIENT_LIST
    GET_PATIENT_LIST: 'GET_PATIENT_LIST',
    ADD_PATIENT_BY_CODE: 'ADD_PATIENT_BY_CODE',
    GET_PAT_GRAPH_DATA: 'GET_PAT_GRAPH_DATA',
    GET_PAT_DETAILS: 'GET_PAT_DETAILS',

}